<pf-dropdown hide-arrow class="user-menu">
    <div slot="button">
        <a class="nav-link">
            <pf-image
                [src]=" user.profile_picture"
                fallback-src="assets/img/default-profile.png"
                class="user-image-small"
                width="25"
                height="25"
                alt="User Image"
                rounded
            ></pf-image>
        </a>
    </div>
    <div slot="menu">
        <li class="user-header bg-primary">
            <pf-image
                [src]=" user.profile_picture"
                fallback-src="assets/img/default-profile.png"
                class="user-image-big"
                alt="User Image"
                width="90"
                height="90"
                rounded
            ></pf-image>

            <p>
                <span>{{ user.email }}</span>
                <small>
                    <span class="mr-2">Membre depuis</span>
                    <span>{{ formatDate(user.created_at) }}</span>
                </small>
            </p>
        </li>
        
        <!-- Menu Footer-->
        <li class="user-footer">
            <a [routerLink]="['/profile']" class="btn btn-default btn-flat">
                Profil
            </a>
            <a (click)="logout()" class="btn btn-default btn-flat float-right">
                Deconnexion
            </a>
        </li>
    </div>
</pf-dropdown>
